export const quantumPageBG = {
  "seo": {
    "title": "Суверенни LLM и Квантов ИИ | pAIoneer Labs GmbH",
    "description": "Нашата цел от Германия: под управлението на Veridion („ИИ развива ИИ напред“) да разработим компактни езикови модели и квантови трансформъри, които в бъдеще ще се конкурират с големите модели от САЩ и Китай."
  },
  "hero": {
    "kicker": "Made in Germany · ИИ развива ИИ",
    "title": "Суверенни LLM и Квантов ИИ",
    "claim": "Нашата цел от Германия: да разработим собствени езикови модели и квантови трансформъри, които в бъдеще ще се конкурират с големите модели от САЩ и Китай.",
    "subtitle": "В реални корпоративни проекти досегашните европейски подходи — немските модели на Aleph Alpha (като Kolibri), френските модели около Mistral, EuroLLM и особено швейцарският модел Apertus — бяха оценени срещу практически бизнес проблеми. Нито един от тях не отговаря на изискванията в компаниите. Затова нашият ИИ под [Veridion](veridion) („ИИ развива ИИ напред“) прави следващата стъпка: изследва и изгражда пътя към компактни езикови модели Made in Germany, които ще бъдат много по-мощни от френските модели, и като втори фокус развива собствени квантови трансформъри.",
    "cta": "Уговорете разговор"
  },
  "pillars": {
    "title": "Върху какво работи нашият ИИ",
    "subtitle": "Две изследователски направления, в които нашите дигитални служители проектират нови архитектури, проверяват ги в симулатор и ги изграждат стъпка по стъпка.",
    "items": [
      {
        "title": "Какво трябва да постига един модел в практиката",
        "description": "В реална работа са решаващи многостъпковото логическо мислене, надеждното използване на инструменти в дълги процеси, чистият софтуерен код и безгрешните офисни задачи. Спрямо това измерваме всяка архитектура от самото начало."
      },
      {
        "title": "Компактни модели за собствена инфраструктура",
        "description": "Вместо все по-огромни центрове за данни, нашата цел ще бъде да съберем висока дълбочина на мислене в компактен модел, който компаниите да могат да управляват локално върху собствен хардуер."
      },
      {
        "title": "Квантови трансформъри и Квантов ИИ",
        "description": "Във второто направление изследваме как трансформър архитектурите се комбинират с параметризирани квантови схеми и тензорни мрежи за разкриване на нови класове модели."
      },
      {
        "title": "Собствена Quantum IDE и квантови процесори",
        "description": "В нашата собствено разработена Quantum IDE ИИ служителите ни проектират, симулират и тестват нови квантови схеми спрямо класически еталони преди изпълнение на реален квантов хардуер."
      }
    ]
  },
  "gate": {
    "title": "От научния анализ до конструктивния план",
    "subtitle": "Всяка стъпка се опира на проверена литература, фирмената ни памет и измерими сравнения.",
    "stages": [
      {
        "step": "Стъпка 01",
        "title": "Анализ на литературата и фирмена памет",
        "description": "Нашите ИИ служители непрекъснато анализират най-новите научни публикации за езикови и квантови архитектури и записват проверените факти в графа на знанията на компанията."
      },
      {
        "step": "Стъпка 02",
        "title": "План за обучение и симулация на схеми",
        "description": "Заедно с продуктовия екип от това се оформя подробният план за обучение на бъдещия ни езиков модел, докато паралелно в Quantum IDE се изпитват нови квантови схеми."
      },
      {
        "step": "Стъпка 03",
        "title": "Научна проверка в IDD процеса",
        "description": "Физици и ИИ изследователи проверяват всяка хипотеза, измерване и проект чрез [Intent-Driven Development](idd) (IDD) като human-in-the-loop и одобряват следващата стъпка."
      }
    ]
  },
  "stack": {
    "title": "Човек и ИИ в общо изследователско звено",
    "subtitle": "Изследванията, продуктовото развитие и научният надзор се допълват във фиксирани цикли.",
    "items": [
      {
        "title": "Дигитални изследователи денонощно",
        "description": "Специализирани ИИ служители извършват проучване на литература, математически изводи, проектиране на схеми и оценка денонощно."
      },
      {
        "title": "Физици в Human-in-the-Loop",
        "description": "Учените задават посоката на изследванията, поставят под въпрос допусканията и вземат решения за одобрения, хардуерни пускания и публикации."
      },
      {
        "title": "Връзка с продуктовото развитие",
        "description": "В тясна координация с продуктовия ни екип доказаните научни резултати преминават директно в нашите инструменти и бъдещи корпоративни решения."
      },
      {
        "title": "Проследимост до самия източник",
        "description": "Всяко архитектурно решение, отхвърлен вариант и измерване остава трайно документирано и проверимо по всяко време."
      }
    ]
  },
  "cta": {
    "title": "Обмен по изследванията",
    "subtitle": "Искате да обсъдим нашите изследвания върху суверенни езикови модели и квантови трансформъри? Пишете ни.",
    "button": "Изпратете съобщение"
  }
};
